module.exports = __webpack_public_path__ + "static/media/syno.1ce01680.png";